export default __webpack_public_path__ + "static/media/light.992d0a57.svg";